module.exports = __webpack_public_path__ + "static/media/participation-state-checkmark.5215eeb0.svg";